import { render, staticRenderFns } from "./TenantEditWeb.vue?vue&type=template&id=1affff64&scoped=true&"
import script from "./TenantEditWeb.vue?vue&type=script&lang=js&"
export * from "./TenantEditWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1affff64",
  null
  
)

export default component.exports